import type { ReactNode } from "react";
import { bubble, type BubbleDirection } from "@web/theme/theme";

export type BubbleProps = { direction: BubbleDirection; children: ReactNode; /** Time · status line under the bubble. */ caption?: ReactNode; className?: string };

/** One conversation message: inbound on the left, outbound on the right (SPEC §6.1 item 11). */
export function Bubble({ direction, children, caption, className = "" }: BubbleProps) {
  return (
    <div className={`${bubble.wrap[direction]} ${className}`.trim()}>
      <div className={`${bubble.base} ${bubble.tone[direction]}`}>{children}</div>
      {caption && <span className={bubble.caption}>{caption}</span>}
    </div>
  );
}

/** A centered system line in a thread (logged calls, status notes). */
export function SystemRow({ children }: { children: ReactNode }) {
  return <p className={bubble.system}>{children}</p>;
}
